import { GraphicLinkList } from '../graphic-link-list/graphic-link-list';
import { IGraphicLink } from '../graphic-link-list/graphic-link-list-model';

import styles from './anchor-link-list.module.scss';

export const AnchorLinkList = ({ items }: { items: IGraphicLink[] }) => {
  return (
    <div className={styles.anchorLinkList}>
      <GraphicLinkList linkList={items} />
    </div>
  );
};
